import { useIsVendor } from "@/hooks/useIsVendor";

/** Feature key for Ready for Orders in features JSON (mainSidebarItems) */
export const READY_FOR_ORDERS_FEATURE_KEY = "LaunchedProducts";

const LABELS = {
  /** Shown to TJ / non-vendor users */
  default: { title: "Launched Products", submenuName: "Launched Products" },
  /** Shown to vendor users */
  vendor: { title: "Launched Products", submenuName: "Launched Products" },
} as const;

/**
 * Returns the display label for the "Ready for Orders" tile and its submenu
 * based on whether the logged-in user is a vendor.
 * Use this hook everywhere the tile or submenu name is shown (dashboard, sidebar, breadcrumbs)
 * so changing the label in one place reflects everywhere.
 */
export function useReadyForOrdersLabel(): {
  title: string;
  submenuName: string;
} {
  const isVendor = useIsVendor();
  return isVendor ? LABELS.vendor : LABELS.default;
}
